import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-screen" }
const _hoisted_2 = { class: "flex flex-row shadow-inner flex-grow" }
const _hoisted_3 = { class: "flex flex-col bg-white w-72 px-4 py-8" }
const _hoisted_4 = { class: "flex flex-row items-center justify-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "FILTER BY STATUS", -1)
const _hoisted_6 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 text-gray-500",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 text-gray-500",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col mt-2"
}
const _hoisted_13 = { class: "flex flex-row items-center justify-between my-1" }
const _hoisted_14 = { class: "bg-background rounded py-1 px-2" }
const _hoisted_15 = { class: "flex flex-row items-center justify-between my-1" }
const _hoisted_16 = { class: "bg-background rounded py-1 px-2" }
const _hoisted_17 = { class: "flex flex-row items-center justify-between my-1" }
const _hoisted_18 = { class: "bg-background rounded py-1 px-2" }
const _hoisted_19 = { class: "flex flex-row items-center justify-between my-1" }
const _hoisted_20 = { class: "bg-background rounded py-1 px-2" }
const _hoisted_21 = { class: "flex flex-row items-center justify-between my-1" }
const _hoisted_22 = { class: "bg-background rounded py-1 px-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-gray-300 my-4" }, null, -1)
const _hoisted_24 = { class: "flex flex-row items-center justify-between" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "FILTER BY COMPANY", -1)
const _hoisted_26 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 text-gray-500",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 text-gray-500",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "flex flex-col mt-2"
}
const _hoisted_33 = { class: "flex flex-row items-center justify-between my-1" }
const _hoisted_34 = { class: "bg-background rounded py-1 px-2" }
const _hoisted_35 = { class: "bg-background rounded py-1 px-2" }
const _hoisted_36 = { class: "flex flex-col flex-grow bg-background shadow-inner p-8" }
const _hoisted_37 = { class: "flex flex-row items-center justify-end" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5 text-white",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Add new team member")
], -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "flex flex-row items-center mt-4 -ml-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("button", { class: "btn-text" }, "Apply", -1)
const _hoisted_42 = {
  key: 2,
  class: "flex flex-col justify-between h-full"
}
const _hoisted_43 = { class: "grid grid-cols-1 xl:grid-cols-2 gap-4 mt-4" }
const _hoisted_44 = { class: "flex flex-row justify-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_TalentCard = _resolveComponent("TalentCard")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openFilterStatus = !_ctx.openFilterStatus)),
          class: "text-gray-500 font-semibold"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (_ctx.openFilterStatus)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
              : (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
          ])
        ]),
        (_ctx.openFilterStatus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_RadioButton, {
                  modelValue: _ctx.status,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.status) = $event)),
                  value: "all_status",
                  label: "All"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.filterStatusOptions.total), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_RadioButton, {
                  modelValue: _ctx.status,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.status) = $event)),
                  value: "not_started",
                  label: "New members"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.filterStatusOptions.not_started), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_RadioButton, {
                  modelValue: _ctx.status,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.status) = $event)),
                  value: "started",
                  label: "Started hiring"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.filterStatusOptions.started), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_RadioButton, {
                  modelValue: _ctx.status,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.status) = $event)),
                  value: "pending_hiring",
                  label: "Pending hiring"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.filterStatusOptions.pending_hiring), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_RadioButton, {
                  modelValue: _ctx.status,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.status) = $event)),
                  value: "hired",
                  label: "Hired"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.filterStatusOptions.hired), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_23,
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openFilterCompany = !_ctx.openFilterCompany)),
          class: "text-gray-500 font-semibold"
        }, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            (_ctx.openFilterCompany)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_26, _hoisted_28))
              : (_openBlock(), _createElementBlock("svg", _hoisted_29, _hoisted_31))
          ])
        ]),
        (_ctx.openFilterCompany)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_RadioButton, {
                  modelValue: _ctx.company,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.company) = $event)),
                  value: "all_company",
                  label: "All"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.filterStatusOptions.total), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterCompanyOptions, (option, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "flex flex-row items-center justify-between my-1"
                }, [
                  _createVNode(_component_RadioButton, {
                    modelValue: _ctx.company,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.company) = $event)),
                    value: option.id,
                    label: option.visible_name
                  }, null, 8, ["modelValue", "value", "label"]),
                  _createElementVNode("div", _hoisted_35, _toDisplayString(option.talents_count), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/add-talent'))),
            class: "btn-filled-lg ml-8"
          }, _hoisted_39)
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createVNode(_component_SearchInput, {
            modelValue: _ctx.searchQuery,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchQuery) = $event)),
            name: "searchQuery",
            placeholder: "Search talent..."
          }, null, 8, ["modelValue"]),
          _hoisted_41
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
          : (_ctx.error)
            ? (_openBlock(), _createBlock(_component_ErrorState, { key: 1 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talents, (talent, i) => {
                    return (_openBlock(), _createBlock(_component_TalentCard, {
                      key: i,
                      talent: talent,
                      class: "cursor-pointer"
                    }, null, 8, ["talent"]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_v_pagination, {
                    modelValue: _ctx.currentPage,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.currentPage) = $event)),
                    pages: _ctx.pagination.total_pages,
                    "range-size": 1,
                    "active-color": "#8908F9"
                  }, null, 8, ["modelValue", "pages"])
                ])
              ]))
      ])
    ])
  ]))
}